export default {
    setAuthStatus(state, status) {
        state.loggedIn = status;
    },
    setToken(state, token) {
        state.token = token;
    }
}
